// extracted by mini-css-extract-plugin
export default {"benefitsItem":"oc1GTS","benefitsItemTitle":"eZKNSB","benefitsItemSubTitle":"kc0uSP","benefitsItemTickIcon":"YnxH5Q"};